export default "__VITE_PUBLIC_ASSET__8dc9a65f__"